// extracted by mini-css-extract-plugin
module.exports = {"quantityControls":"style_quantityControls__1ULup","quantityInput":"style_quantityInput__1LidO"};